// import { createTheme } from '@mui/material';

// const myTheme = createTheme({
// 	palette: {
// 		primary: {
// 			main: '#ca0005', // By default color on the button
// 			light: '0 10px 20px rgba(250, 250, 250, 0.19), 0 6px 6px rgba(251, 251, 251, 0.23);',
// 			dark: '#CA0005', // when we hover on the button
// 			contrastText: '#fff', // text color on the button
// 		},
// 		secondary: {
// 			main: '#1976d2',
// 			light: '#42a5f5',
// 			dark: '#1565c0',
// 			contrastText: '#fff',
// 		},
// 		error: {
// 			main: '#ff0063',
// 			light: '#42a5f5',
// 			dark: '#1565c0',
// 			contrastText: '#fff',
// 		},
// 		warning: {
// 			main: '#1976d2',
// 			light: '#42a5f5',
// 			dark: '#1565c0',
// 			contrastText: '#fff',
// 		},
// 		info: {
// 			main: '#000', // black
// 			light: '#42a5f5',
// 			dark: '#0C8040',
// 			contrastText: '#000',
// 		},
// 		success: {
// 			main: '#0C8040',
// 			light: '#42a5f5',
// 			dark: '#CA0005',
// 			contrastText: '#fff',
// 		},

// 		action: {
// 			active: '#ca0005',
// 			hover: '#CA0005',
// 			hoverOpacity: 0.04,
// 			selected: '#ca0005',
// 			selectedOpacity: 0.08,
// 			disabled: 'rgba(0, 0, 0, 0.26)',
// 			disabledBackground: 'rgba(0, 0, 0, 0.12)',
// 			disabledOpacity: 0.38,
// 			focus: 'rgba(0, 0, 0, 0.12)',
// 			focusOpacity: 0.12,
// 			activatedOpacity: 0.12,
// 		},
// 		text: {
// 			primary: '#000',
// 			secondary: '#999999',
// 			disabled: '#4D4D4D',
// 		},
// 	},
// 	components: {
// 		MuiIconButton: {
// 			styleOverrides: {
// 				root: {
// 					'&:hover': {
// 						color: '#fff', // Set content color to white on hover
// 						fill: '#fff', // Set fill color to white on hover
// 					},
// 				},
// 			},
// 		},
// 		MuiSvgIcon: {
// 			styleOverrides: {
// 				root: {
// 					'&:hover': {
// 						color: '#fff', // Set icon color to white on hover
// 					},
// 				},
// 			},
// 		},
// 		MuiListItemButton: {
// 			styleOverrides: {
// 				root: {
// 					'&:hover': {
// 						'& .MuiSvgIcon-root': {
// 							color: '#fff', // Set icon color to white on list item hover
// 							fill: '#fff', // Set fill color to white on list item hover
// 						},
// 					},
// 				},
// 			},
// 		},
// 	},
// });

// export default myTheme;
import { createTheme } from '@mui/material/styles';

const myTheme = createTheme({
	typography: {
		fontFamily: `'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif`,
		h1: { fontWeight: 700 },
		h2: { fontWeight: 600 },
		h3: { fontWeight: 600 },
		h4: { fontWeight: 500 },
		h5: { fontWeight: 500 },
		h6: { fontWeight: 500 },
		body1: { fontWeight: 400 },
		body2: { fontWeight: 300 },
	},
	palette: {
		primary: {
			main: '#ca0005',
			// dark: '#ca0005',
			// light: '#ff6666',
			// contrastText: '#ffffff',
		},
		// secondary: {
		// 	main: '#FDB813',
		// 	// light: '#FFE066',
		// 	// dark: '#CC9A00',
		// 	// contrastText: '#000000',
		// },

		background: {
			default: '#FFF',
			paper: '#ffffff',
		},
		text: {
			primary: '#000000',
			secondary: '#4D4D4D',
			disabled: '#999999',
		},
		error: {
			main: '#ca0005',
		},
		warning: {
			main: '#FFAA00',
		},
		info: {
			main: '#1976d2',
		},
		success: {
			main: '#0C8040',
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: '8px',
					textTransform: 'none',
					fontWeight: 500,
					boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
					// '&:hover': {
					// 	backgroundColor: '#fa3c3c',
					// },
				},
			},
		},
		// MuiButton: {
		// 	styleOverrides: {
		// 		root: ({ ownerState }) => ({
		// 			borderRadius: '8px',
		// 			textTransform: 'none',
		// 			fontWeight: 500,
		// 			boxShadow: '0 4px 10px rgba(0,0,0,0.1)',

		// 			...(ownerState.variant === 'contained' && {
		// 				backgroundColor: '#fa3c3c',
		// 				color: '#fff',
		// 				'&:hover': {
		// 					backgroundColor: '#ca0005',
		// 				},
		// 			}),

		// 			...(ownerState.variant === 'outlined' && {
		// 				border: '1px solid #fa3c3c',
		// 				color: '#fa3c3c',
		// 				'&:hover': {
		// 					backgroundColor: '#fff0f0',
		// 					borderColor: '#ca0005',
		// 					color: '#ca0005',
		// 				},
		// 			}),

		// 			...(ownerState.variant === 'text' && {
		// 				color: '#fa3c3c',
		// 				'&:hover': {
		// 					backgroundColor: '#fff0f0',
		// 					color: '#ca0005',
		// 				},
		// 			}),
		// 		}),
		// 	},
		// },

		MuiIconButton: {
			styleOverrides: {
				root: {
					'&:hover': {
						color: '#000',
						fill: '#000',
					},
				},
			},
		},
		// MuiSvgIcon: {
		// 	styleOverrides: {
		// 		root: {
		// 			'&:hover': {
		// 				color: '#000',
		// 			},
		// 		},
		// 	},
		// },
		MuiListItemButton: {
			styleOverrides: {
				root: {
					'&:hover': {
						backgroundColor: '#ca0005',
						'& .MuiSvgIcon-root': {
							color: '#fff',
							fill: '#fff',
						},
					},
				},
			},
		},
	},
});

export default myTheme;
